import { ReactElement } from 'react';
import Config from '../../../shared/config';
import styles from './EnvironmentBanner.module.scss';

const EnvironmentBanner = (): ReactElement | null => {
    const { environmentLabel } = Config.getConfig();
    if (!environmentLabel) return null;

    return (
        <div className={styles._banner} role="status" aria-label={`Umgebung: ${environmentLabel}`}>
            {environmentLabel}
        </div>
    );
};

export default EnvironmentBanner;
